/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { type PropsWithChildren } from 'react';
import { css, jsx } from '@compiled/react';

export const ActionContainer = ({ children }: PropsWithChildren<{}>) => {
	return <div css={containerStyles}>{children}</div>;
};

const containerStyles = css({
	display: 'flex',
	minHeight: '100%',
	'--open-button-opacity': 0,
	'&:hover': {
		'--open-button-opacity': 1,
	},
	'&:focus-within': {
		'--open-button-opacity': 1,
	},
});
